import { customAlphabet } from 'nanoid'
import { z } from 'zod'

/** Stable entity id: lowercase slug, safe as a Firestore map key and document id. */
export const SLUG_RE = /^[a-z0-9][a-z0-9_-]{0,39}$/
export const Slug = z.string().regex(SLUG_RE, 'Use lowercase letters, numbers, - or _ (max 40)')
export type Slug = z.infer<typeof Slug>

const alphabet = '0123456789abcdefghijklmnopqrstuvwxyz'
const nano = customAlphabet(alphabet, 10)

/** Random id for entities created in the UI. */
export function newId(): string {
  return nano()
}

/** "Saints + Council · Colony Square" → "saints-council-colony-square". */
export function slugify(input: string, max = 40): string {
  const s = input
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, max)
    .replace(/-+$/g, '')
  return s || newId()
}

/** Account ids join brand and platform so one map holds every account for a client. */
export function accountId(brandId: string, platform: string): string {
  return `${brandId}__${platform}`
}
export function splitAccountId(id: string): { brandId: string; platform: string } | null {
  const i = id.lastIndexOf('__')
  if (i <= 0) return null
  return { brandId: id.slice(0, i), platform: id.slice(i + 2) }
}
